import styled from '@emotion/styled'

import { mediaQueryUp } from '~/theme/utils/grid'
import { h4, h5, h6 } from '~/theme/utils/typography'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const PositionWrapper = styled.div`
  display: flex;
  gap: 2px;
  flex-direction: column;

  ${mediaQueryUp('m')} {
  }
`

export const Title = styled.h2<{}>`
  ${h5};
  font-weight: ${({ theme }) => theme.text.fontWeight.semiBold};
  line-height: ${({ theme }) => theme.text.lineHeight.loose};

  ${mediaQueryUp('m')} {
    ${h4};
    font-weight: ${({ theme }) => theme.text.fontWeight.semiBold};
    line-height: ${({ theme }) => theme.text.lineHeight.loose};
  }
`

export const Description = styled.p<{ fullWidth?: boolean }>`
  color: ${({ theme }) => theme.colors.gray[600]};
  font-size: ${({ theme }) => theme.text.fontSize.s};

  ${mediaQueryUp('l')} {
    max-width: ${({ fullWidth = false }) => (fullWidth ? '100%' : 'calc(100% - 256px - 12px)')};
  }
`

export const Content = styled(Description)`
  color: ${({ theme }) => theme.colors.gray[900]};
  max-width: 500px;
  white-space: pre-wrap;
  line-height: 26px;
  ${props => h6(props)};
  font-weight: ${({ theme }) => theme.text.fontWeight.medium};
`
